// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"sectionTitle_sectionTitle__Ptd5u"};